import { defineComponent, ref, onMounted, watch, createElementBlock, openBlock, normalizeStyle, normalizeClass, createCommentVNode, Fragment, renderList, createVNode, createBlock } from 'vue';
import _sfc_main$1 from './basler-components.es236.js';
/* empty css                        */

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "TeaserCards",
  props: {
    items: {},
    gridType: { default: "stretch" },
    headerGutter: { type: Boolean, default: false },
    linkIconPosition: { default: "content" },
    maxColumns: { default: 3 }
  },
  setup(__props) {
    const props = __props;
    const everyNth = (arr, nth, offset = 0) => {
      return arr.filter((item, index) => {
        return (index + offset) % nth === nth - 1;
      });
    };
    const createMasonryCols = (columns2) => {
      const masonryCols2 = [];
      for (let i = 0; i < columns2; i++) {
        const offset = columns2 - i - 1;
        masonryCols2[i] = everyNth(props.items, columns2, offset);
      }
      return masonryCols2;
    };
    const columns = ref(1);
    const createCols = () => {
      if (props.maxColumns >= 2 && window.innerWidth > 576) {
        columns.value = 2;
      }
      if (props.maxColumns >= 3 && window.innerWidth >= 992) {
        columns.value = 3;
      }
      return createMasonryCols(columns.value);
    };
    const throttle = (func, delay) => {
      let timer = 0;
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => func.apply(this, args), delay);
      };
    };
    const masonryCols = ref(createMasonryCols(1));
    onMounted(() => {
      masonryCols.value = createCols();
      const resizeObserver = new ResizeObserver(
        throttle(() => {
          masonryCols.value = createCols();
        }, 200)
      );
      resizeObserver.observe(document.body);
    });
    watch(
      () => props.items,
      () => {
        masonryCols.value = createCols();
      },
      { deep: true }
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("ul", {
        class: normalizeClass({ "teaser-cards": true, [`teaser-cards--${props.gridType}`]: true }),
        style: normalizeStyle(`--teaser-max-columns: ${props.maxColumns}; --teaser-columns: ${columns.value};`)
      }, [
        props.gridType === "stretch" ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(props.items, (item, index) => {
          return openBlock(), createElementBlock("li", {
            key: `${index}-${item.header}-${item.headline}`,
            class: "teaser-cards__item"
          }, [
            createVNode(_sfc_main$1, {
              "max-columns": props.maxColumns,
              link: item.link,
              header: item.header,
              badge: item.badge,
              headline: item.headline,
              content: item.content,
              footer: item.footer,
              "header-gutter": props.headerGutter,
              "link-icon-position": props.linkIconPosition,
              "tag-list": item.tagList,
              "is-loading": item.isLoading,
              "loading-lines": item.loadingLines,
              date: item.date,
              "teaser-card-data-attributes": item.teaserCardDataAttributes ?? void 0
            }, null, 8, ["max-columns", "link", "header", "badge", "headline", "content", "footer", "header-gutter", "link-icon-position", "tag-list", "is-loading", "loading-lines", "date", "teaser-card-data-attributes"])
          ]);
        }), 128)) : createCommentVNode("", true),
        props.gridType === "masonry" ? (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList(masonryCols.value, (items, colIndex) => {
          return openBlock(), createElementBlock("li", {
            key: `${colIndex} ${items.length}`,
            class: "teaser-cards__item"
          }, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(items, (item, index) => {
              return openBlock(), createBlock(_sfc_main$1, {
                key: `${index}-${item.header}-${item.headline}`,
                link: item.link,
                header: item.header,
                badge: item.badge,
                headline: item.headline,
                content: item.content,
                footer: item.footer,
                "header-gutter": props.headerGutter,
                "link-icon-position": props.linkIconPosition,
                "tag-list": item.tagList,
                date: item.date,
                "teaser-card-data-attributes": item.teaserCardDataAttributes ?? void 0
              }, null, 8, ["link", "header", "badge", "headline", "content", "footer", "header-gutter", "link-icon-position", "tag-list", "date", "teaser-card-data-attributes"]);
            }), 128))
          ]);
        }), 128)) : createCommentVNode("", true)
      ], 6);
    };
  }
});

export { _sfc_main as default };
